import { prefix } from 'utils/mappers';

export const prefixName = name => prefix(name, { value: 'views.menu.' });
